// @ngInject
function AcpEsignPaywallDialogComponentCtrl(acpCoreDispatcher, $scope) {
  $scope.close = function() {
    acpCoreDispatcher.dialog.hide.emit({
      name: 'acpPaywallEsignDialog'
    });
  };
}

export default AcpEsignPaywallDialogComponentCtrl;
